import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { usePermissions } from '../hooks/usePermissions';
import { LogOut, User } from 'lucide-react';
import { COLORS } from '../config/theme';
import { BRAND } from '../config/brand';

const Header = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { role } = usePermissions();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="bg-white shadow-sm border-b" style={{ borderColor: COLORS.border }}>
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 md:h-20">
          {/* Logo Motore Gare DS */}
          <div className="flex items-center">
            <button
              onClick={() => navigate('/dashboard')}
              className="flex items-center transition-opacity hover:opacity-80"
            >
              {/* Mobile: logo compatto */}
              <img
                src={`${process.env.PUBLIC_URL || ''}/logo_little.png`}
                alt={`${BRAND.productName} - ${BRAND.companyName}`}
                className="h-10 w-auto md:hidden"
              />
              {/* Desktop: logo standard */}
              <img
                src={`${process.env.PUBLIC_URL || ''}/logo.svg`}
                alt={`${BRAND.productName} - ${BRAND.companyName}`}
                className="hidden md:block h-12 w-auto"
              />
            </button>
          </div>

          {/* User info */}
          <div className="flex items-center gap-3 md:gap-6">
            <div className="flex items-center gap-3">
              {/* Desktop: icona + email. Mobile: solo ruolo */}
              <User className="hidden md:block h-5 w-5" style={{ color: COLORS.text2 }} />
              <span className="hidden md:inline text-sm font-medium" style={{ color: COLORS.text2 }}>
                {user?.email || 'N/A'}
              </span>

              {role && (
                <span
                  className="px-3 py-1 text-xs font-semibold rounded-full"
                  style={{ backgroundColor: COLORS.softBlue, color: COLORS.primary }}
                >
                  {role.toUpperCase()}
                </span>
              )}
            </div>

            <button
              onClick={handleLogout}
              className={[
                "flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 text-xs md:text-sm font-medium rounded-lg",
                "transition-colors border",
                "focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
              ].join(' ')}
              style={{ color: COLORS.text, borderColor: COLORS.border }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = COLORS.bg)}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
            >
              <LogOut className="h-4 w-4" />
              <span className="hidden md:inline">Logout</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

